export enum CurrenciesEnum {
    Eur = 'EUR',
    Usd = 'USD',
    Gbp = 'GBP',
    Xpf = 'XPF',
}